/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApplicationCredentialsDto,
  MultiEntityApplicationCreationDto,
  MultiEntityUpsellRequestDto,
  OrganisationOverview,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMultiEntityController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-multi-entity-controller
   * @name SendMultiEntityUpsellRequest
   * @request POST:/api/v1/multientity/upsell
   */
  sendMultiEntityUpsellRequest = (data: MultiEntityUpsellRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/multientity/upsell`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static sendMultiEntityUpsellRequestPath = '/v1/multientity/upsell'
  static sendMultiEntityUpsellRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-multi-entity-controller
   * @name CreateMultiEntityApplication
   * @request POST:/api/v1/multientity/applications
   */
  createMultiEntityApplication = (
    data: MultiEntityApplicationCreationDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ApplicationCredentialsDto, any>({
      path: `/v1/multientity/applications`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMultiEntityApplicationPath = '/v1/multientity/applications'
  static createMultiEntityApplicationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-multi-entity-controller
   * @name FindById5
   * @request GET:/api/v1/multientity/organisations/{id}
   */
  findById = (id: string, params: RequestParams = {}) =>
    this.http.request<OrganisationOverview, any>({
      path: `/v1/multientity/organisations/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/multientity/organisations/${id}'
  static findByIdMethod = 'GET'
}
